import { Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_PRECISION, Utils, SELECTED_VENDOR } from '@app/_helpers';

@Pipe({
  name: 'earningsFormatter'
})
export class EarningsFormatterPipe implements PipeTransform {

  transform(value: number, shortUnit?: boolean, precision?:number, ...args: unknown[]): string | number {
    if (value === null ||
      value === undefined) {
      return value;
    }
    let formattedValue = value.toString();
    /*
    This pipe  formats the number to the below formats
    For values below 10,000
    The values are show as it is.
    For values below 100,000 and greater than equal to 10,000 (Example: 25,556.55)
    The value are shown as 25.55K
    For values below 100,00,000 and greater than or equal to 100,000 (Example: 25,55,555.66)
    The value is shown as 25.55L
    For values greater than or equal to 100,00,000 (Example: 2,55,66,666.66)
    The value is shown as 2.55Cr
    */

    if (value >= 1e7 || value <= -1e7) {
      value = value / 1e7;
      value = this.round(value);
      formattedValue = `${value.toLocaleString(SELECTED_VENDOR.locale)}${shortUnit ? 'Cr' : ' Crores'}`;
    } else if (value >= 1e5 || value <= -1e5) {
      value = value / 1e5;
      value = this.round(value);
      formattedValue = `${value.toLocaleString(SELECTED_VENDOR.locale)}${shortUnit ? 'L' : ' Lakhs'}`;
    } else if (value >= 1e4 || value <= -1e4) {
      value = value / 1e3;
      value = this.round(value);
      formattedValue = `${value.toLocaleString(SELECTED_VENDOR.locale)}${shortUnit ? 'K' : ' Thousands'}`;
    }
    else {
      formattedValue = `${value.toLocaleString(SELECTED_VENDOR.locale)}`;
      const parts = formattedValue.split('.');
      formattedValue = parts.length === 1 ? `${formattedValue}.00` : formattedValue;
    }

    return formattedValue;
  }

  /*
  This function truncates any number to 2 decimal places.
  Suppose we have 1056 it gives 10.56 as the output without rounding off values
  The Math.trunc function removes all fractional values.
  Suppose for 123.95 it will be 123
  */
  round(value: number) {
    return Math.round(value * 100) / 100;
  }

}
